import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
 import SendIcon from '@material-ui/icons/Send';
const useStyles = makeStyles({
  table: {
    minWidth: 650,

  },
  tc:{
 whiteSpace: "nowrap"
  }
});

function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [
  createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
  createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
  createData('Eclair', 262, 16.0, 24, 6.0),
  createData('Cupcake', 305, 3.7, 67, 4.3),
  createData('Gingerbread', 356, 16.0, 49, 3.9),
];

export default function BasicTable({data:{orders_list}}) {
  const classes = useStyles();
if(orders_list.length===0)
return(
  <Typography   variant="subtitle1" align="center">
             No orders placed so far
            </Typography>
)
  return (

       <Table className={classes.table} aria-label="simple table">
         <TableHead>
          <TableRow>
              {/*<TableCell className={classes.tc}>Order Id</TableCell>*/}
               <TableCell  className={classes.tc}>Application Form No.</TableCell>
               <TableCell  className={classes.tc}>Date</TableCell>
                 {/*TableCell  >Type </TableCell>*/}
              <TableCell>Amount</TableCell>
            <TableCell className={classes.tc}>Payment Status</TableCell>
                <TableCell className={classes.tc}>View Details</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {orders_list.length>0 && orders_list.map((row,i) => (
            <TableRow key={i}>
               <TableCell component="th" scope="row">
{!row.roll_no?'Not generated yet':row.roll_no}
            </TableCell>
               {/*<TableCell component="th" scope="row">
{row.uid}
              </TableCell>
              */}
   <TableCell className={classes.tc}>{row.created_at}</TableCell>
                  {/*<TableCell className={classes.tc}>{row.order_type}</TableCell>*/}
                 <TableCell className={classes.tc}>&#8377; {row.amount} </TableCell>
                <PaymentStatus classes={classes} status={row.status} uid={row.uid}/>
                  <ViewDetails classes={classes}   uid={row.uid}/>
            </TableRow>
          ))}
        </TableBody>
      </Table>

  );
}




const PaymentStatus=({status,classes,uid})=>{
let style={}
const is_paid=status==='paid';
  if(!is_paid)
  style={color:'red',fontWeight:'bold'}
  else
  style={color:'teal'}
  return(
    <TableCell className={classes.tc}  style={style}>

    {status.toUpperCase()}
    {
      !is_paid &&
      <>&nbsp;&nbsp;<Button variant="contained"  color="primary" disableElevation
 endIcon={<SendIcon/>}

 href={`http://localhost/reliable-erp/payment-gateway/pay.php?uid=${uid}`}
      >
      PAY
   </Button>
   </>
    }


    </TableCell>
  )
}


const ViewDetails=({classes,uid})=>{



  return(
    <TableCell className={classes.tc}  >


 <Button    color="primary" disableElevation


 href={`./orders/${uid}`}
      >
      View
   </Button>


    </TableCell>
  )
}
